import { Chip, TableBodyCell, TableCellEmpty } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { ProjectStatusChip } from 'app/domains/projects';
import { TypeAvatarWithLabel } from 'shared/domains/common-ui';
import { IdChip } from '../../IdChip';
import { StyledTableRow } from '../PickerTableFilesystem/styled';
export function ProjectRow(props) {
    const { project, selected, onToggle } = props;
    const { id, name, customerId, documentsCount, status } = project;
    const handleToggle = () => onToggle({ id, name });
    // Renders the checkbox without making it clickable on its own, the row click handles selection
    const nOop = () => { };
    return (<StyledTableRow $hoverCursor $selected={selected} onClick={handleToggle}>
      <TableBodyCell headers="cell:name">
        <TypeAvatarWithLabel truncate multiselect size="sm" type="project" title={name} selected={selected} onSelect={nOop}/>
      </TableBodyCell>
      <TableBodyCell headers="cell:customerId">
        {customerId ? <IdChip size="small" type="project" id={customerId}/> : <TableCellEmpty />}
      </TableBodyCell>
      <TableBodyCell headers="cell:documents">
        <Chip size="small" appearance={documentsCount > 0 ? 'info' : 'secondary'} icon={<Falcon icon="file"/>} label={documentsCount.toString()}/>
      </TableBodyCell>
      <TableBodyCell headers="cell:status">
        <ProjectStatusChip status={status}/>
      </TableBodyCell>
    </StyledTableRow>);
}
